// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1kn4d","addWidgetButton":"Header_addWidgetButton__1rO9F","dashboardTabs":"Header_dashboardTabs__1p0Eq","active":"Header_active__2JKPV"};